import _ from 'lodash';
import React from 'react';
import Select from 'react-select';

import {
  FormField,
  HelpBlock,
  Label,
  Row,
  selectorProps,
} from '../../common/form';
import FundContext from './context';

export default function withNameSelect(name, label, isMulti = false) {
  const kebab = _.kebabCase(name);
  const capitalize = _.capitalize(name);
  const lbl = _.lowerCase(label || name);

  function PlainSelect() {
    const { state, dispatch } = React.useContext(FundContext);

    const handleChange = selected => dispatch({ type: `set${capitalize}`, payload: selected });

    return (
      <Row>
        <Label htmlFor={kebab}>{lbl}</Label>
        <FormField>
          <Select
            {...selectorProps}
            isMulti={isMulti}
            className={kebab}
            value={state.fund[name]}
            options={state[`${name}Options`]}
            placeholder={`Select ${lbl}`}
            onChange={handleChange}
            closeMenuOnSelect={!isMulti}
            hideSelectedOptions={!isMulti}
          />
          {state.errors[name] && <HelpBlock>{state.errors[name]}</HelpBlock>}
        </FormField>
      </Row>
    );
  }

  PlainSelect.displayName = capitalize;

  return PlainSelect;
}
